import chartTitles from '../chartTitles'
import withToolbar from '../withToolbar'
import LineChart from './LineChart'

export default withToolbar(LineChart, {
  pdfExport: {
    title: 'Heart Rate Chart'
  },
  timeWindow: 7 * 4,
  childProps: {
    type: 'heart_rate',
    yAxisLabel: 'Heat Rate (bpm)',
    title: chartTitles.heart_rate
  }
})
